
import { ReminderService, SaleService } from "@/services";
import { DocumentLayoutInfo } from "@/utils/documents/layout-info";
import { SaleLayoutInfo } from "@/utils/sale-layouts/sale-layout-info";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			saleLayouts: [] as SaleLayoutInfo[],
			reminderLayouts: [] as DocumentLayoutInfo[],
			selectedSaleLayouts: [] as SaleLayoutInfo[],
			selectedReminderLayouts: [] as DocumentLayoutInfo[],
			confirming: false
		};
	},
	props: {
		show: {
			type: Boolean,
		},
		title: {
			type: String,
			required: true
		},
		ignoreSaleLayouts: Boolean,
		ignoreReminderLayouts: Boolean,
		confirmHandler: Function
	},
	computed: {
		hasItemsSelected():boolean {
			if (this.selectedSaleLayouts.length != 0){
				return true;
			}
			if (this.selectedReminderLayouts.length != 0){
				return true;
			}
			return false;
		}
	},
	watch: {
		show(){
			this.selectedSaleLayouts = [];
			this.selectedReminderLayouts = [];
			if (this.show){
				this.fetch();
			}
		},
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async confirm(){
			this.confirming = true;
			try{
				if (this.selectedSaleLayouts.length > 0){
					this.$emit("sale-layouts", this.selectedSaleLayouts);
				}
				if (this.selectedReminderLayouts.length > 0) {
					this.$emit("reminder-layouts", this.selectedReminderLayouts);
				}
				if (this.confirmHandler){
					await this.confirmHandler(this.selectedSaleLayouts, this.selectedReminderLayouts);
				}else{
					this.$emit("close");
				}
			}catch(err){
			}finally{
				this.confirming = false;
			}
		},
		toggleSaleLayout(item:SaleLayoutInfo){
			let i = this.selectedSaleLayouts.indexOf(item);
			if (i == -1) {
				this.selectedSaleLayouts.push(item);
			}else{
				this.selectedSaleLayouts.splice(i,1);
			}
		},
		getSaleLayoutChecked(item:SaleLayoutInfo):boolean{
			if (this.selectedSaleLayouts.indexOf(item) == -1){
				return false;
			}
			return true;
		},
		toggleReminderLayout(item:DocumentLayoutInfo){
			let i = this.selectedReminderLayouts.indexOf(item);
			if (i == -1) {
				this.selectedReminderLayouts.push(item);
			}else{
				this.selectedReminderLayouts.splice(i,1);
			}
		},
		getReminderLayoutChecked(item:DocumentLayoutInfo):boolean {
			if (this.selectedReminderLayouts.indexOf(item) == -1){
				return false;
			}
			return true;
		},
		async fetch(){
			if (this.saleLayouts.length == 0) {
				this.saleLayouts = await SaleService.getSaleLayouts();
			}
			if (this.reminderLayouts.length == 0){
				this.reminderLayouts = await ReminderService.getReminderLayouts();
			}
		},
		toggleAllSaleLayoutsChecked(){
			if (this.allSaleLayoutsChecked()) {
				this.selectedSaleLayouts = [];
			}else{
				this.selectedSaleLayouts = [...this.saleLayouts];
			}
		},
		allSaleLayoutsChecked():boolean{
			return this.selectedSaleLayouts.length == this.saleLayouts.length;
		},
		toggleAllReminderLayoutsChecked(){
			if (this.allReminderLayoutsChecked()) {
				this.selectedReminderLayouts = [];
			}else{
				this.selectedReminderLayouts = [...this.reminderLayouts];
			}
		},
		allReminderLayoutsChecked():boolean{
			return this.selectedReminderLayouts.length == this.reminderLayouts.length;
		}
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
